import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the checkoutStep1Page state domain
 */

const selectCheckoutStep2PageDomain = (state: ApplicationRootState) => {
  return state ? state : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by CheckoutStep1Page
 */

const selectCheckoutStep2Page = () =>
  createSelector(selectCheckoutStep2PageDomain, substate => {
    return substate;
  });

export default selectCheckoutStep2Page;
export { selectCheckoutStep2PageDomain };
